/*
 * Exposes console if available. Otherwise, does nothing.
 */

const doNothing = function () {};

const theConsole = console || {
  log: doNothing,
  dir: doNothing,
  error: doNothing,
  info: doNothing,
  warn: doNothing
};

export default theConsole;
